const [ w, d, mq ] = [ window, document, window.matchMedia( "(max-width: 900px)" ) ]

const init = () => {

  if( w.load['loadHtml'] ) {
    $.when( w.load['loadHtml']).then(() => {
      $('.breadcrumbs').before( $('.mainImg') );
    });
  }

}

export default function SERVICE() {
  $( init )
}